import React from 'react';
import { PropTypes } from 'prop-types';
import AsyncSelect from './AsyncSelect';
import CommonDataService from '../../services/CommonDataService';

class CountrySelect extends React.Component {

  constructor(props) {
    super(props);

    this.countrySearch = this.countrySearch.bind(this);
  }

  countrySearch(input) {

    const params = { searchText: input };

    return CommonDataService
      .getCountries(params)
      .then(data => {
        return { options: data || [] };
      });
  }

  render() {

    const { name, autoload, multi, onSearch, ...rest } = this.props;

    return (
      <AsyncSelect
        {...rest}
        name={name}
        autoload={autoload}
        multi={multi}
        onSearch={this.countrySearch} />
    );
  }
}

CountrySelect.defaultProps = {
  multi: true,
  autoload: false
};

CountrySelect.propTypes = {
  name: PropTypes.string.isRequired,
  multi: PropTypes.bool,
  autoload: PropTypes.bool
};

export default CountrySelect;



// WEBPACK FOOTER //
// ./src/components/form/CountrySelect.js